import React, { useEffect, useState } from "react";
import { apiGet, apiPost } from "./EmailApi";
import "./BackupRecoverySection.css";

function BackupRecoverySection() {
  const [emails, setEmails] = useState([]);
  const [backups, setBackups] = useState([]);
  const [form, setForm] = useState({
    businessEmailId: "",
    backupName: "",
    backupType: "manual",
    backupSize: "250MB",
  });

  const fetchData = async () => {
    try {
      const [emailsRes, backupsRes] = await Promise.all([
        apiGet("/api/email/my-emails"),
        apiGet("/api/email/backups"),
      ]);

      setEmails(emailsRes?.data || []);
      setBackups(backupsRes?.data || []);
    } catch (error) {
      console.error("Backup fetch failed:", error);
    }
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 10000);
    return () => clearInterval(interval);
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();

    const data = await apiPost("/api/email/backups", form);

    if (data?.success) {
      setForm({
        businessEmailId: "",
        backupName: "",
        backupType: "manual",
        backupSize: "250MB",
      });
      fetchData();
    } else {
      alert(data?.message || "Failed to create backup");
    }
  };

  const handleRestore = async (id) => {
    const data = await apiPost(`/api/email/backups/${id}/restore`);

    if (data?.success) {
      fetchData();
    } else {
      alert(data?.message || "Failed to restore backup");
    }
  };

  return (
    <div className="email-panel-card br-section">
      <div className="br-header">
        <div>
          <span className="br-badge">Email Safety</span>
          <h2>Backup & Recovery</h2>
          <p>
            Create email backups, manage restore points, and recover important
            business communication safely.
          </p>
        </div>

        <div className="br-icon-card">
          <span>♻️</span>
        </div>
      </div>

      <form className="email-panel-form br-form" onSubmit={handleCreate}>
        <select
          value={form.businessEmailId}
          onChange={(e) =>
            setForm({ ...form, businessEmailId: e.target.value })
          }
        >
          <option value="">Select Business Email</option>
          {emails.map((item) => (
            <option key={item.id} value={item.id}>
              {item.email_address}
            </option>
          ))}
        </select>

        <input
          type="text"
          placeholder="Backup Name"
          value={form.backupName}
          onChange={(e) => setForm({ ...form, backupName: e.target.value })}
        />

        <select
          value={form.backupType}
          onChange={(e) => setForm({ ...form, backupType: e.target.value })}
        >
          <option value="manual">Manual</option>
          <option value="scheduled">Scheduled</option>
          <option value="recovery-point">Recovery Point</option>
        </select>

        <input
          type="text"
          placeholder="Backup Size"
          value={form.backupSize}
          onChange={(e) => setForm({ ...form, backupSize: e.target.value })}
        />

        <button type="submit">Create Backup</button>
      </form>

      <div className="br-summary-row">
        <div>
          <strong>{backups.length}</strong>
          <span>Total Backups</span>
        </div>
        <div>
          <strong>{emails.length}</strong>
          <span>Business Emails</span>
        </div>
        <div>
          <strong>10s</strong>
          <span>Auto Refresh</span>
        </div>
      </div>

      <div className="email-panel-list br-list">
        {backups.map((item) => (
          <div className="email-panel-item br-item" key={item.id}>
            <div className="br-item-top">
              <div>
                <h4>{item.backup_name}</h4>
                <p>Email: {item.email_address}</p>
              </div>

              <span className="br-status">{item.backup_status}</span>
            </div>

            <div className="br-meta-grid">
              <p>Type: {item.backup_type}</p>
              <p>Size: {item.backup_size}</p>
              <p>
                Last Restored: {item.last_restored_at || "Not restored yet"}
              </p>
            </div>

            <button type="button" onClick={() => handleRestore(item.id)}>
              Restore Backup
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BackupRecoverySection;